(function ($, Drupal) {
  'use strict';
  $(document).ready(function () {
    const personEntity = $('.referenz-persons-wrapper');
    if (personEntity.length) {
      $('.tooltip-person').tooltip({
        track: true,
        position: { my: "left+30 top-50%", at: "right+50 top-80%", collision: "flipfit" },
        items: ".tooltip-person[data-tooltip]",
        show: { effect: "blind", duration: 2800 },
        content: function () {
          return $(this).attr('data-tooltip');
        },
        classes: {
          "ui-tooltip": "tooltip-person-description"
        }
      });
      let windowWidth = $(window).width();
      window.addEventListener('resize', function (event) {
        windowWidth = $(window).width();
        disableTooltip(windowWidth , 768)
      });
      disableTooltip(windowWidth , 768)
    }

    function disableTooltip(windowWidth , width) {
      if (windowWidth < width) {
        $(".tooltip-person").tooltip("disable");
      } else {
        $(".tooltip-person").tooltip("enable");
      }
    }
    // debug open always tooltips
    // $(".tooltip-person").tooltip().tooltip("open");
  })//  document ready
})(jQuery, Drupal);